export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {
      org1: {
        title: 'Name <i>of</i> Organization in schema',
        type: 'string'
      },
      org2: {
        title: 'ERROR - THIS SHOULD NOT BE VISIBLE',
        type: 'string'
      },
      selectQuestion: {
        title: '<i>Select</i> Question',
        type: 'string',
        enum: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
        enumNames: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6']
      },
      radio: {
        title: '<i>Radio</i> question',
        type: 'string',
        enum: ['OPTION_1', 'OPTION_2', 'OPTION_3'],
        enumNames: ['Option 1', 'Option 2', 'Option 3']
      },
      checkboxes: {
        title: '<i>Checkbox list</i> question',
        type: 'string',
        enum: ['OPTION_1', 'OPTION_2', 'OPTION_3'],
        enumNames: ['Option 1', 'Option 2', 'Option 3']
      },
      checkbox: {
        title: '<i>Checkbox</i> question',
        type: 'string'
      },
      city1: {
        title: 'City',
        type: 'string'
      },
      state1: {
        title: 'State',
        type: 'string',
        enum: ['WI', 'Other'],
        enumNames: ['WI', 'Other']
      },
      country1: {
        title: 'Country',
        type: 'string',
        enum: ['USA', 'Other'],
        enumNames: ['USA', 'Other']
      }
    }
  },
  uiSchema: {
    org1: {
      'ui:widget': 'text',
      'ui:title': {
        escape: false
      }
    },
    org2: {
      'ui:widget': 'text',
      'ui:title': {
        text: 'Name <i>of</i> Organization in uiSchema',
        escape: false
      },
      'ui:help': 'help me!'
    },
    selectQuestion: {
      'ui:widget': 'select',
      'ui:placeholder': 'Select...',
      'ui:title': {
        text: '<i>Select</i> Question',
        escape: false
      }
    },
    123456789: {
      'ui:title': {
        text: 'Some <b>bold</b> label',
        escape: false
      }
    },
    radio: {
      'ui:widget': 'radio',
      'ui:title': {
        escape: false
      }
    },
    checkbox: {
      'ui:widget': 'checkbox',
      'ui:title': {
        escape: false
      }
    },
    checkboxes: {
      'ui:widget': 'checkboxes',
      'ui:title': {
        escape: false
      }
    },
    city1: {
      'ui:widget': 'text'
    },
    state1: {
      'ui:widget': 'select'
    },
    country1: {
      'ui:widget': 'select'
    },
    group_1123456: {
      'ui:title': {
        text: 'City, State <i>and</i> Country 1',
        escape: false
      }
    },
    110001: {
      'ui:title': ','
    },
    'dm:layout': [{
      type: 'field',
      id: 'org1'
    }, {
      type: 'text',
      id: '123456789'
    }, {
      type: 'field',
      id: 'org2'
    }, {
      type: 'select',
      id: 'selectQuestion'
    }, {
      type: 'field',
      id: 'radio'
    }, {
      type: 'field',
      id: 'checkbox'
    }, {
      type: 'field',
      id: 'checkboxes'
    }, {
      id: 'group_1123456',
      type: 'group',
      children: [{
        type: 'field',
        id: 'city1'
      }, {
        type: 'field',
        id: 'state1'
      }, {
        type: 'text',
        id: '110001'
      }, {
        type: 'field',
        id: 'country1'
      }]
    }]
  },
  formData: {}
};